import api from "./api";
import { IExtra, IGroup, IProduct, IStep, IStore } from "../classes/interfaces";

export function unwrap<T>(res: { data: { code?: number; data?: T } }): T {
  if (res.data === undefined || res.data.code === undefined) {
    throw new Error("Resposta inválida da API");
  }
  if (res.data.code !== 200) {
    throw new Error(`Erro da API: código ${res.data.code}`);
  }
  return res.data.data as T;
}

export async function getStoreBySuffix(suffix: string): Promise<IStore> {
  const res = await api().get(`/store/suffix/${suffix}`);
  return unwrap<IStore>(res);
}

export async function getGroupsForStore(storeId: string): Promise<IGroup[]> {
  const res = await api().get(`/store/${storeId}/groups/products`);
  return unwrap<IGroup[]>(res);
}

export async function getProductExtras(productId: string): Promise<IExtra[]> {
  const res = await api().get(`/product/${productId}/extras`);
  return unwrap<IExtra[]>(res);
}

export async function getProductSteps(
  productIds: string,
  sizeId?: string
): Promise<IStep[]> {
  const query = sizeId ? `?sizeId=${sizeId}` : "";
  const res = await api().get(`/products/${productIds}/steps${query}`);
  return unwrap<IStep[]>(res);
}

export async function getSizeProducts(
  sizeId: string,
  groupId: string
): Promise<IProduct[]> {
  const res = await api().get(`/size/${sizeId}/products?groupId=${groupId}`);
  return unwrap<IProduct[]>(res);
}
